import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CardBasic, BasicTable, Scroller } from "extranet-component-library";
import { SictmApi } from "../api/sictm.api";
import star from "../assets/img/star.svg";
import download from '../assets/img/download.svg';
import ModalTimetables from "../components/ModalTimetables";
import { showSnackbar } from '../utils/parsers';


interface FavsProps {
  favLines: Array<any>;
}

const Timetables = ({ ...props }: FavsProps) => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    timetables: [],
    clicked: -1,
    modal: false,
  });

  const openModalTimetable = async (data: any) => {
    try {
      const res = await SictmApi.getTimetables(
        data.lineId
      );
      switch (res.length) {
        case 0:
          showSnackbar(true);
          break;
        case 1:
          downloadTimetable(res[0].url);
          break;
        default:
          setState({ ...state, modal: true, timetables: res });
          break;
      }
    } catch (err) {
    }
  };

  const downloadTimetable = (url: any) => {
    window.open(
      url,
      "_blank"
    );
  };

  const closeModal = () => {
    setState({ timetables: [], modal: false, clicked: -1 });
  };

  return (
    <>
      <ModalTimetables
        timetables={state.timetables}
        clicked={state.clicked}
        visible={state.modal}
        download={downloadTimetable}
        setClicked={(index: number) => setState({ ...state, clicked: index })}
        close={closeModal}
      />
      <div className="card">
        <CardBasic
          content={
            <>
              <div className="card-title">
                <img src={star} alt="fav" style={{ marginRight: "1rem" }} />
                {t("fav_lines").toUpperCase()}
              </div>
              <Scroller
                height="180px"
                content={
                  <BasicTable
                    items={props.favLines}
                    emptyString={t("no_items")}
                    actionLabel={t("download_timetables")}
                    icon={download}
                    headers={[
                      { id: "code", label: t("code") },
                      { id: "name", label: t("name") },
                      { id: "action", label: "" },
                    ]}
                    onActionClick={(row) => openModalTimetable(row)}
                  />
                }
              />
            </>
          }
        />
      </div>
    </>
  );
};

export default Timetables;
